import { setDialog } from "slices/appSlice";

/**
 * Validate a workspace CLOB *object or string*.
 * Returns the stringified JSON if valid, or null if invalid (and shows a dialog).
 */
export const validateAndStringifyClob = (clob, dispatch, isRules) => {
  if (clob == null) {
    dispatch(
      setDialog({
        title: "Invalid data",
        message: "workspaceClob is empty or undefined.",
      })
    );
    return null;
  }

  let clobString;
  let clobObject;

  // 1) Ensure we can stringify it
  try {
    clobString = typeof clob === "string" ? clob : JSON.stringify(clob);
  } catch (err) {
    dispatch(
      setDialog({
        title: "Invalid data",
        message: `workspaceClob cannot be serialized to JSON: ${
          (err && err.message) || err
        }`,
      })
    );
    return null;
  }

  // 2) Ensure it’s valid JSON when parsed back
  try {
    clobObject = typeof clob === "string" ? JSON.parse(clob) : clob;
  } catch (err) {
    dispatch(
      setDialog({
        title: "Invalid JSON",
        message: `workspaceClob contains invalid JSON: ${
          (err && err.message) || err
        }`,
      })
    );
    return null;
  }

  // 3) Light structural validation – customize as needed
  if (!Array.isArray(clobObject.PolicyBusinessRulesList)) {
    dispatch(
      setDialog({
        title: "Invalid structure",
        message: "workspaceClob.PolicyBusinessRulesList must be an array.",
      })
    );
    return null;
  }

  // Optional: sanity-check first rule
  if (isRules && clobObject.PolicyBusinessRulesList.length > 0) {
    const rulesList = clobObject.PolicyBusinessRulesList;
    const lastRule = rulesList[rulesList.length - 1];
    const ruleHeader = lastRule && lastRule.RuleHeader;
    if (!ruleHeader || typeof ruleHeader.RuleFlowGroup !== "string") {
      dispatch(
        setDialog({
          title: "Invalid structure",
          message:
            "Each rule should have a RuleHeader with a RuleFlowGroup value.",
        })
      );
      return null;
    }
  }

  return clobString;
};
